<div class="container full-height">
  <div class="row h-100">
    <div class="col align-items-center d-flex justify-content-md-center ">
      <div class="card border-0">
        <article class="card-body">
          <h4 class="card-title text-center mb-0 mt-1"><img alt="logo" class="center-block" src="assets/logo.gif"></h4>
          <hr>

          <ngb-alert *ngIf="success" [dismissible]="false" [type]="'success'">
            {{success}}
          </ngb-alert>
          <ngb-alert *ngIf="error" (close)="error=''" [type]="'danger'">
            {{error}}
          </ngb-alert>

          <form (ngSubmit)="onSubmit()" #newPasswordForm="ngForm" *ngIf="!success">

            <div class="form-group">
              <label for="newPassword">Enter your current password</label>
              <div class="input-group">
                <input [type]="hidePassword ? 'password' : 'text'" id="oldPassword" name="oldPassword" class="form-control" placeholder="Current Password"
                       required [(ngModel)]="passwordChange.oldPassword" #oldPassword="ngModel"
                       autocomplete="current-password" (ngModelChange)="onPwChange($event)">
                <div class="input-group-append">
                  <span class="input-group-text" (click)="toggleHidePassword()">
                    <fa-icon *ngIf="!hidePassword" [icon]="faEyeSlash"></fa-icon>
                    <fa-icon *ngIf="hidePassword" [icon]="faEye"></fa-icon>
                  </span>
                </div>
              </div> <!-- input-group// -->
            </div> <!-- form-group// -->

            <div class="form-group">
              <label for="newPassword">Enter your new password</label>
              <div class="input-group">
                <input [type]="hideNewPassword ? 'password' : 'text'" id="newPassword" name="newPassword" class="form-control" placeholder="New Password"
                       required [(ngModel)]="passwordChange.newPassword" #newPassword="ngModel"
                       autocomplete="new-password" (ngModelChange)="onPwChange($event)">
                <div class="input-group-append">
                  <span class="input-group-text" (click)="toggleHideNewPassword()">
                    <fa-icon *ngIf="!hideNewPassword" [icon]="faEyeSlash"></fa-icon>
                    <fa-icon *ngIf="hideNewPassword" [icon]="faEye"></fa-icon>
                  </span>
                </div>
              </div> <!-- input-group// -->
            </div> <!-- form-group// -->

            <div class="form-group" *ngIf="hideNewPassword">
              <label for="verifyPassword">Re-type your new password</label>
              <input type="password" id="verifyPassword" name="verifyPassword" class="form-control" placeholder="Re-type Password"
                     required [(ngModel)]="passwordChange.verifyPassword" #verifyPassword="ngModel"
                     autocomplete="new-password" (ngModelChange)="onPwChange($event)">
              <div class="js-invalid-feedback" *ngIf="verifyPassword?.errors && verifyPassword.errors?.mismatch">
                {{verifyPassword.errors.mismatch}}
              </div>
            </div> <!-- form-group// -->
            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-block" [disabled]="!newPasswordForm.valid">Submit new password</button>
            </div> <!-- form-group// -->
          </form>
          <p class="text-center"><a [routerLink]="['/']" class="btn">Back to home</a></p>
        </article>
      </div> <!-- card.// -->
    </div>
  </div>
</div>


